import {registerComponent} from '../utils/registry';

export class MapSpeechBubblesHero {
    private pointsArray: Array<{ bottom: string, left: string }> = [];
    private bubblesAmount = 0;

    constructor() {
        const container = document.getElementById('speech-bubble-container');
        this.bubblesAmount = container
            ? container.getElementsByClassName('speech-bubble').length
            : 0;
    }

    public init(): void {
        if (this.bubblesAmount === 0) {
            console.warn('MapSpeechBubblesHero: No speech bubbles found.');
            return;
        }

        this.updatePointsArray();
        window.addEventListener('resize', () => this.updatePointsArray());

        // Start the first animation cycle
        this.popIn(0);
    }

    private updatePointsArray(): void {
        this.pointsArray = this.getLocationPoints();
    }

    private getPrevious(index: number): number {
        return index > 0 ? index - 1 : this.bubblesAmount - 1;
    }

    private getNext(index: number): number {
        return index + 1 < this.bubblesAmount ? index + 1 : 0;
    }

    private popIn(index: number): void {
        const item = document.getElementById(`speech_bubble_${index}`);
        const foundPoint = this.pointsArray[index];
        if (!item || !foundPoint) return;

        const el = item as HTMLElement;
        el.style.bottom = foundPoint.bottom;
        el.style.left = foundPoint.left;
        el.style.display = 'block';
        el.style.opacity = '1';

        setTimeout(() => {
            this.fadeOut(this.getPrevious(index));
        }, 500);
    }

    private fadeOut(index: number): void {
        const item = document.getElementById(`speech_bubble_${index}`);
        if (!item) return;

        const el = item as HTMLElement;
        el.style.opacity = '1';

        const fadeOutHandler = setInterval(() => {
            const opacity = Number(el.style.opacity);
            if (opacity <= 0) {
                el.style.display = 'none';
                clearInterval(fadeOutHandler);

                // Show next bubble after delay
                setTimeout(() => {
                    this.popIn(this.getNext(this.getNext(index)));
                }, 2000);
            } else {
                el.style.opacity = String(opacity - 0.05);
            }
        }, 10);
    }

    private getLocationPoints(): Array<{ bottom: string, left: string }> {
        const pointsArray: Array<{ bottom: string, left: string }> = [];
        const elements = Array.from(
            document.getElementsByClassName('location-point')
        ) as HTMLElement[];

        const svg = document.getElementById('country-map-svg');
        if (!svg) return [];

        const svgRect = svg.getBoundingClientRect();
        const bubbleWidth = 156;

        elements.forEach(element => {
            const rect = element.getBoundingClientRect();
            const pointWidth = rect.width;
            const pointHeight = rect.height;

            pointsArray.push({
                bottom: `${svgRect.bottom - rect.bottom + pointHeight}px`,
                left: `${rect.left - svgRect.left - bubbleWidth / 2 + pointWidth / 2}px`,
            });
        });

        return pointsArray.reverse();
    }
}

const hero = registerComponent('mapSpeechBubblesHero', new MapSpeechBubblesHero());
hero.init();
